<template>
  <div class="news">
    <!-- <el-row :gutter="16" v-if="isPc == 1"> -->
    <!-- <el-col :span="24" v-for="item in newsListRes" :key="item.newsId"> -->
    <div class="news-list">
      <div :class="['news-item', imgDirection]" v-for="item in newsListRes" :key="item.newsId" @click="toDetails(item)">
        <img v-if="item.newsImage" :src="item.newsImage" class="news-img hand" />
        <div class="news-info">
          <!-- <div class="items-center justify-between">
              <span class="bg-red text-white font14">{{ item.newstype }}</span>
              <time class="text-grey font14">{{ item.releaseTime }}</time>
            </div> -->
          <h3 class="text-black font18">
            {{ item.newsTitle }}
          </h3>
          <p v-html="item.brief"></p>
          <div class="tag" v-if="type !== 'expert'">
            <em>{{ item.newstype }}</em>&nbsp;{{ item.tag ? '·' : '' }}&nbsp; <span>{{ item.tag }}</span>
          </div>
          <div v-if="type === 'expert'" class="tag">
            <img v-if="item.authorAvatar" :src="item.authorAvatar" alt="" srcset="">
            <img v-else src="@/assets/images/default-avatar.png" alt="">
            <span style="color:#2C2C2E;">{{ item.author }}</span>
            <b v-if="item.brief"> · </b>
            <span v-html="item.brief"></span>
            <b v-if="item.linkMagazine"> · </b>
            <span style="color:#E2291E;">{{ item.linkMagazine ? L('摘自' + item.linkMagazine) : '' }}</span>
          </div>
        </div>
      </div>
    </div>

    <!-- </el-col> -->
    <!-- </el-row> -->
    <!-- <el-row :gutter="0" v-if="isPc != 1">
      <el-col :span="24" v-for="item in newsListRes" :key="item.newsId">
        <div class="news-item" @click="toDetails(item.newsId)">
          <img :src="item.newsImage" class="news-img hand" />
          <div class="news-info">
            <div class="items-center justify-between">
              <span class="bg-red text-white font14">{{ item.newstype }}</span>
              <time class="text-grey font14">{{ item.releaseTime }}</time>
            </div>
            <h3 class="text-black font18">
              {{ item.newsTitle }}
            </h3>
          </div>
        </div>
      </el-col>
    </el-row> -->
    <div v-if="ispagination" class="justify-center" style="padding-bottom: 50px">
      <pagination :current-page="pageNum" :page-size="pageSize" :total="total" @changeSize="changeSize" />
    </div>
  </div>
</template>

<script>
import pagination from "./pagination.vue";
import { getNewsList } from "@/assets/api/news.js";
import { mapState } from "vuex";

export default {
  components: {
    pagination,
  },
  props: {
    typeId: {
      type: String,
      default: "",
    },
    ispagination: {
      type: Boolean,
      default: true,
    },
    imgDirection: {
      type: String,
      default: "flex-row",
    },
    newsId: {
      type: String,
      default: "",
    },
    type: {
      type: String,
      default: "",
    },
    newsTitle: {
      type: String,
      default: "",
    },
  },
  computed: {
    ...mapState(["isPc"]),
  },
  data() {
    return {
      newsListRes: [],
      total: 0,
      pageNum: 1,
      pageSize: 6,
    };
  },
  created() {
    this.init();
  },
  watch:{
    newsTitle(){
      this.init();
    }
  },
  methods: {
    init() {
      let params = {
        orderByColumn: "releaseTime",
        isAsc: "desc",
        typeId: this.typeId,
        pageNum: this.pageNum,
        pageSize: this.pageSize,
        slideshow: 0,
        newsId: this.newsId,
        // newsTitle: this.newsTitle,
      }
      console.log('this.keyword====', this.newsTitle.includes('#'))
      if (this.newsTitle.includes('#')) {
        // 如果是#号开头，则认为是标签,去掉#号  
        params.tag = this.newsTitle.replace('#', '')
      } else {
        // 如果不是#号开头，则认为是新闻标题
        params.newsTitle = this.newsTitle
      }
      getNewsList(params).then((res) => {
        // console.log(res.data);
        this.total = res.data.total;
        this.newsListRes = res.data.rows.map((item) => {
          item.newsImage = item.newsImage ? !/^http/.test(item.newsImage)
            ? this.$imgUrl + item.newsImage
            : item.newsImage : '';
          item.author=item.authorV2?item.authorV2:item.author;
          item.authorAvatar=item.authorAvatarV2?item.authorAvatarV2:item.authorAvatar;
          item.authorAvatar = item.authorAvatar ? !/^http/.test(item.authorAvatar)
            ? this.$imgUrl + item.authorAvatar
            : item.authorAvatar : '';
          item.tag = item.tag.split('|').join(' · ');
          return item;
        });
      });
    },
    changeSize(e) {
      console.log(e);
      this.pageNum = e;
      this.init();
    },
    toDetails(item) {
      if (this.newsTitle) {
        this.$emit('toDetails', item);
        return;
      }
      if (item.url) {
        window.open(item.url, "_blank");
      } else {
        localStorage.setItem('newsId', item.newsId);
        let path = item.seoUrl ? item.seoUrl : item.newsId
        this.$router.push({
          // path: `/article-details/${newsId}`,
          path: `/${path}.html`,
        });
      }
    },
    generateSlug(title) {
      // 将标题中的空格替换为连字符
      let slug = title.toLowerCase().replace(/\s+/g, '-');
      // 将连字符替换为单个连字符
      slug = slug.replace(/-+/g, '');
      slug = slug.replace(/:+/g, '');
      return slug;
    },
  },
};
</script>

<style lang="less" scoped>
.news {
  .news-list {
    margin-bottom: 60px;
  }

  .news-item {
    background: #fff;
    padding: 30px 0;
    border-bottom: 1px solid #E5E5EA;
    display: flex;
    align-items: center;
    cursor: pointer;

    .news-img {
      width: 200px;
      height: 128px;
      border-radius: 8px;
      margin-right: 16px;
      object-fit: cover;
    }

    .news-info {
      h3 {
        font-family: MicrosoftYaHei, MicrosoftYaHei;
        font-weight: bold;
        font-size: 24px;
        color: #2C2C2E;
        line-height: 31px;
        text-align: left;
        font-style: normal;
        overflow: hidden;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
        word-break: break-all;
      }

      p {
        font-family: MicrosoftYaHei, MicrosoftYaHei;
        font-weight: normal;
        font-size: 20px;
        color: #636366;
        line-height: 26px;
        text-align: left;
      }

      .tag {
        margin-top: 16px;
        font-family: MicrosoftYaHei;
        font-size: 14px;
        color: #AEAEB2;
        line-height: 19px;
        text-align: left;
        display: flex;
        align-items: center;

        img {
          width: 24px;
          height: 24px;
          border-radius: 24px;
          object-fit: cover;
          margin-right: 8px;
        }

        em {
          color: #E2291E;
        }
      }
    }

    &:hover {
      h3 {
        color: #E2291E;
      }
    }
  }

  .flex-col {
    align-items: flex-start;

    .news-img {
      width: 100%;
      height: 244px;
      object-fit: cover;
      margin: 0;
      margin-bottom: 16px;
    }
  }

  .news-item:first-child {
    padding-top: 0;
  }

  .flex-row.news-item:first-child {
    flex-direction: column;
    align-items: flex-start;
    padding-top: 0;

    .news-img {
      width: 100%;
      height: auto;
      max-height: 507px;
      object-fit: cover;
      margin: 0;
      margin-bottom: 30px;
    }

    h3 {
      font-family: MicrosoftYaHei, MicrosoftYaHei;
      font-weight: bold;
      font-size: 32px;
      color: #2C2C2E;
      line-height: 42px;
      text-align: left;
      font-style: normal;
    }
  }


}

@media screen and (max-width: 768px) {
  .news {
    margin: 0;

    .news-list {
      border-bottom: none;
    }

    .news-item {
      background: #fff;
      margin-bottom: 0;

      padding: 20px 0;
      border-bottom: 1px solid #E5E5EA;

      .news-img {
        width: 110px;
        min-width: 110px;
        height: 70px;
        object-fit: cover;
      }

      .news-info {
        padding: 0;
        margin-top: 0;

        .tag {
          margin-top: 6px;
          font-size: 12px;
        }

        span {
          font-family: MicrosoftYaHei;
          font-size: 12px;
          color: #AEAEB2;
          line-height: 16px;
          text-align: left;
          font-style: normal;
          padding: 0;
        }

        time {
          font-family: NotoSansCJKTC;
          font-weight: bold;
          line-height: 1.71;
          letter-spacing: 0.7px;
        }

        h3 {
          font-family: MicrosoftYaHei, MicrosoftYaHei;
          font-weight: bold;
          font-size: 18px;
          color: #2C2C2E;
          line-height: 24px;
          text-align: left;
          font-style: normal;
          height: 48px;
        }
      }
    }

    .flex-col {
      .news-img {
        width: 100%;
        height: 244px;
        object-fit: cover;
      }
    }

    .flex-row.news-item:first-child {
      .news-img {
        margin-bottom: 12px;
        height: 225px;

      }

      h3 {
        font-family: MicrosoftYaHei, MicrosoftYaHei;
        font-weight: bold;
        font-size: 18px;
        color: #2C2C2E;
        line-height: 24px;
        text-align: left;
        font-style: normal;
        height: 48px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/common/news-list.vue